import React, { useEffect, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Polyline,
  Popup,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const LocationTrackerMap = () => {
  const [positions, setPositions] = useState([]);

  // Custom icon to fix missing default marker icons
  const customIcon = new L.Icon({
    iconUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
  });

  useEffect(() => {
    let lastUpdateTime = 0;

    const watchId = navigator.geolocation.watchPosition(
      (position) => {
        const now = Date.now();
        if (now - lastUpdateTime >= 60000) {
          // 60,000 ms = 1 minute
          lastUpdateTime = now;
          const { latitude, longitude } = position.coords;
          setPositions((prev) => [...prev, [latitude, longitude]]);
        }
      },
      (error) => {
        console.error("Error getting location:", error);
      },
      { enableHighAccuracy: true }
    );

    return () => navigator.geolocation.clearWatch(watchId);
  }, []);

  const latestPosition = positions[positions.length - 1];

  return (
    <div style={{ height: "100vh" }}>
      {latestPosition && (
        <MapContainer
          center={latestPosition}
          zoom={13}
          style={{ height: "100%" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&copy; OpenStreetMap contributors"
          />
          {positions.map((pos, idx) => (
            <Marker position={pos} icon={customIcon} key={idx}>
              <Popup>Point {idx + 1}</Popup>
            </Marker>
          ))}
          <Polyline positions={positions} color="blue" />
        </MapContainer>
      )}
    </div>
  );
};

export default LocationTrackerMap;
